import template	from "./dialog-config.html";
import css		from "./dialog-config.css";

import Dialog	from "dialog";

import ColorPicker from "../../controls/textbox-colorpicker.js";


class ConfigIlluminationDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-illumination", ConfigIlluminationDialog);
  }
  connectedCallback() {
    super.connectedCallback();

    this.onupdatedevices_handler_f = this.onupdatedevices_handler.bind(this);
    document.addEventListener("onupdatedevices", this.onupdatedevices_handler_f);

    this.onupdatedevices_handler({detail: application.devices});    
    
    this.colorPicker.value = application.devices.illumination.rgb;
  }
  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener("onupdatedevices", this.onupdatedevices_handler_f);
  }    
  constructor(...args) {
    super(...args);

    this.show(...args);
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices.illumination.id;    
    this.textboxDeviceStatus.value = devices.illumination.status;    
  }    
  async colorPicker_change() {
    console.log("colorPicker_change", this.colorPicker.value);
    server.rcall("RM_illumination_setRGB", this.colorPicker.value);
  }  
  buttonClose_click() {
    this.close();
  }
}

ConfigIlluminationDialog.constructor();

export default ConfigIlluminationDialog;